import { NgModule } from '@angular/core';
import { NewModalModule } from 'outshared-lib';
import { NoCoverageModalComponent } from './no-coverage-modal.component';

/** @deprecated - this is moved to libs/shared/feature-coverage-modals */
@NgModule({
    imports: [
        NewModalModule,
    ],
    exports: [NoCoverageModalComponent],
    declarations: [NoCoverageModalComponent],
    providers: [],
})
export class NoCoverageModalModule { }
